// i18n
import { translateInComponent, changeLanguage } from 'infras/i18n';
import translations from 'presentations/views/components/pages/PrivacyPolicyPage/i18n.json';

import MainDocument from 'presentations/views/components/MainDocument';
import { GetServerSideProps } from 'next';
import PrivacyPolicyPage from 'presentations/views/components/pages/PrivacyPolicyPage';
import Breadcrumbs from 'presentations/views/components/organisms/Breadcrumbs';
import Header from 'presentations/views/components/organisms/Header';
import { setBreadcrumbs } from 'presentations/views/helpers/breadcrumbs';
import { apiPath, privacyPolicyPath } from 'presentations/routes/path';
import { get } from 'infras/rest_client';
import { useContext } from 'react';
import { ResourceListItem } from 'presentations/api/schema/resources';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';

interface ServerProps {
  content: string;
}

export const getServerSideProps: GetServerSideProps = async ({
  locale,
}: any) => {
  changeLanguage(locale);
  const t = translateInComponent(translations);
  const result = await get(apiPath(`/v1/resources/${t('url')}`));
  if (!result.isSuccess) {
    console.log(result.errorMessage);
    return { props: { statusCode: 404 } };
  }
  const resource: ResourceListItem = result.data;
  const props: ServerProps = {
    content: resource.body,
  };
  return { props };
};

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  const breadcrumbs = [];
  breadcrumbs.push({
    title: t('title'),
    link: privacyPolicyPath(),
  });
  const routes = setBreadcrumbs(breadcrumbs);

  return (
    <MainDocument title={t('title')} isNoIndex={true}>
      <PrivacyPolicyPage
        header={<Header viewer={viewer} />}
        breadcrumbs={<Breadcrumbs routes={routes} />}
        body={props.content}
      />
    </MainDocument>
  );
}
